import { BreakpointObserver } from "@angular/cdk/layout";
import { Injectable, Signal, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { map } from "rxjs";

// CLAAS package breakpoints — @claas/claas-theme-component/src/lib/styles/breakpoints
const MOBILE_PHONE_MAX_WIDTH = "(max-width: 600px)";
const TABLET_MAX_WIDTH = "(max-width: 960px)";
const LAPTOP_MAX_WIDTH = "(max-width: 1280px)";

/**
 * Exposes the app's breakpoints as signals, backed by a single shared
 * BreakpointObserver subscription per query. Mirrors the breakpoints defined in
 * @claas/claas-theme-component/src/lib/styles/breakpoints so components don't
 * each wire up their own BreakpointObserver.observe() calls.
 */
@Injectable({ providedIn: "root" })
export class ResponsiveService {
  private readonly breakpointObserver = inject(BreakpointObserver);

  readonly isMobilePhone = this.toMatchSignal(MOBILE_PHONE_MAX_WIDTH);
  readonly isTablet = this.toMatchSignal(TABLET_MAX_WIDTH);
  readonly isLaptop = this.toMatchSignal(LAPTOP_MAX_WIDTH);

  private toMatchSignal(query: string): Signal<boolean> {
    return toSignal(
      this.breakpointObserver
        .observe(query)
        .pipe(map((state) => state.matches)),
      { initialValue: this.breakpointObserver.isMatched(query) },
    );
  }
}
